import { PageConfig } from '../state/landing-types';

export const buildMarketingPageCanonicalHref = (
  slug: string,
  category?: string
) => ['https://streamable.com', category, slug].filter(Boolean).join('/');
